import React from "react";

const FormSubmitButtonField = ({ children }) => (
  <div className="field">
    <button className="button is-primary" type="submit">
      {children}
    </button>
  </div>
);

export default FormSubmitButtonField;
